import { X } from "lucide-react";
import { useT } from "../i18n";

const AVAILABILITIES = ["disponible", "liste_attente", "complet", "a_confirmer"];
const LABEL_CLS = "block text-xs uppercase tracking-[0.15em] font-semibold text-[#0D4045] mb-2";

export default function FilterPanel({ meta, commune, setCommune, availability, setAvailability, specialty, setSpecialty, hasFilters, onClear }) {
  const { t } = useT();
  return (
    <>
      <div>
        <label className={LABEL_CLS}>{t("filters.commune")}</label>
        <select data-testid="filter-commune-select" value={commune} onChange={(e) => setCommune(e.target.value)}
          className="w-full min-h-[48px] rounded-xl border border-[#0D4045]/15 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30">
          <option value="">{t("filters.all")}</option>
          {meta.communes.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div>
        <label className={LABEL_CLS}>{t("filters.availability")}</label>
        <div className="flex flex-wrap gap-2">
          {AVAILABILITIES.map((a) => (
            <button key={a} data-testid={`filter-availability-${a}`} onClick={() => setAvailability(availability === a ? "" : a)}
              className={`px-4 py-2.5 rounded-full text-sm font-semibold border transition-colors duration-200 ${
                availability === a ? "bg-[#0D4045] text-[#FDFBF7] border-[#0D4045]" : "bg-white text-[#1F2937] border-[#0D4045]/15 hover:border-[#0D4045]/40"
              }`}>
              {t(`status.${a}`)}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label className={LABEL_CLS}>{t("filters.specialty")}</label>
        <div className="flex flex-wrap gap-2" data-testid="filter-specialty-chips">
          <button data-testid="filter-specialty-all" onClick={() => setSpecialty("")}
            className={`px-3.5 py-2 rounded-full text-xs font-semibold border transition-colors duration-200 ${
              !specialty ? "bg-[#0D4045] text-[#FDFBF7] border-[#0D4045]" : "bg-[#E8F3F1] text-[#0D4045] border-transparent hover:bg-[#d7eae6]"
            }`}>
            {t("filters.all")}
          </button>
          {meta.specialties.map((s) => (
            <button key={s} data-testid={`filter-specialty-${s}`} onClick={() => setSpecialty(specialty === s ? "" : s)}
              className={`px-3.5 py-2 rounded-full text-xs font-semibold border transition-colors duration-200 ${
                specialty === s ? "bg-[#0D4045] text-[#FDFBF7] border-[#0D4045]" : "bg-[#E8F3F1] text-[#0D4045] border-transparent hover:bg-[#d7eae6]"
              }`}>
              {t(`specialty.${s}`)}
            </button>
          ))}
        </div>
      </div>
      {hasFilters && (
        <button data-testid="clear-filters-btn" onClick={onClear}
          className="flex items-center gap-1.5 text-sm font-semibold text-[#6B7280] hover:text-[#0D4045] transition-colors duration-200">
          <X size={15} /> {t("filters.clear")}
        </button>
      )}
    </>
  );
}
